import { Stack, useRouter, usePathname } from "expo-router";
import React from "react";

import { LocaleContext } from "./contexts";
import { useTranslateText } from "./utils/translations";
import { useUserAuthChange } from "./hooks";

export default function RootStack() {
  const { navigate, replace } = useRouter();
  const pathname = usePathname();
  const translations = useTranslateText();
  useUserAuthChange({
    loginAction: () => {
      if (pathname === "/") {
        navigate("./tpos");
      }
    },
    logoutAction: () => {
      replace("./");
    },
  });

  return (
    <LocaleContext.Provider value={translations}>
      <Stack
        initialRouteName="index"
        screenOptions={{
          headerShown: false,
        }}
      >
        <Stack.Screen
          name="index"
          options={{
            title: "Auth",
          }}
        />
        <Stack.Screen
          name="tpos"
          options={{
            title: "TPOS Home",
          }}
        />
        <Stack.Screen
          name="pickup-drive-thru"
          options={{
            title: "Pickup Drive thru",
          }}
        />
        <Stack.Screen
          name="pickup-drive-thru-verified"
          options={{
            title: "Order Verified",
          }}
        />
        <Stack.Screen name="+not-found" />
      </Stack>
    </LocaleContext.Provider>
  );
}
